import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft" && onPrev) onPrev();
      if (e.key === "ArrowRight" && onNext) onNext();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  if (index == null || !images || !images[index]) return null;

  return createPortal(
    <div
      data-testid="gallery-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Pratinjau gambar diperbesar"
      className="fixed inset-0 z-[70] bg-black/85 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close-button"
        aria-label="Tutup"
        onClick={onClose}
        className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20 transition-colors"
      >
        <X size={20} />
      </button>
      {onPrev && (
        <button
          data-testid="lightbox-prev-button"
          aria-label="Gambar sebelumnya"
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          className="absolute left-3 sm:left-6 w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20 transition-colors"
        >
          &#8592;
        </button>
      )}
      <figure className="max-w-4xl max-h-[86vh]" onClick={(e) => e.stopPropagation()}>
        <img
          src={images[index].src}
          alt={images[index].alt}
          className="max-w-full max-h-[78vh] object-contain rounded-md"
        />
        {images[index].alt && (
          <figcaption className="text-center text-white/70 text-sm mt-3">{images[index].alt}</figcaption>
        )}
      </figure>
      {onNext && (
        <button
          data-testid="lightbox-next-button"
          aria-label="Gambar berikutnya"
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          className="absolute right-3 sm:right-6 w-11 h-11 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20 transition-colors"
        >
          &#8594;
        </button>
      )}
    </div>,
    document.body
  );
}

